/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu'
import { LinqService, QueryOptions } from 'linquest'
import { OneOnOneMeetingDto } from './models'

/**
 * MeetingApi - API class
 */
export class MeetingApi extends LinqService {
  /**
   * Creates a new MeetingApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider)
  }

  /**
   */
  requestMeetingAsync(dto?: OneOnOneMeetingDto, options?: QueryOptions) {
    // create query
    const url = `/Meeting/RequestMeetingAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }
}
